import {
  CREDIT_UPDATE,
  LOGIN_SUCCESS,
  LOGOUT,
  PAGE_LOAD,
  SAVE_CONTENT,
  SET_USER_DATA,
  SET_TAGS,
  TAG_CREATED,
  TAG_UPDATED,
  TAG_DELETED,
} from "./constants";

const initialState = {
  tags: {
    list: [],
    loading: false,
    error: null,
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return Array.isArray(state) ? [...state, action.data] : { ...state, userData: action.data };
    case LOGIN_SUCCESS:
      return {
        ...state,
        userLoggedIn: action.payload.user,
        userToken: action.payload.token,
      };
    case LOGOUT:
      return {
        ...state,
        userLoggedIn: null,
        userToken: null,
        tags: {
          list: [],
          loading: false,
          error: null,
        },
      };
    case PAGE_LOAD:
      return {
        ...state,
        pageLoaded: action.payload,
      };
    case CREDIT_UPDATE:
      return {
        ...state,
        userLoggedIn: {
          ...state.userLoggedIn,
          credits: action.payload,
        },
      };
    case SET_TAGS:
      return {
        ...state,
        tags: {
          list: action.payload || [],
          loading: false,
          error: null,
        },
      };
    case TAG_CREATED:
      return {
        ...state,
        tags: {
          ...state.tags,
          list: action.payload ? [...state.tags.list, action.payload] : state.tags.list,
        },
      };
    case TAG_UPDATED:
      return {
        ...state,
        tags: {
          ...state.tags,
          list: state.tags.list.map((tag) =>
            tag._id === action.payload?._id ? action.payload : tag
          ),
        },
      };
    case TAG_DELETED:
      return {
        ...state,
        tags: {
          ...state.tags,
          list: state.tags.list.filter((tag) => tag._id !== action.payload),
        },
      };
    // case SAVE_CONTENT: 
    //   return {
    //     ...state,
    //     content: action.payload,
    //   };
    // case SAVE_CONTENT: 
    // return {
    //   ...state,
    //   content: [...state.content, action.payload],
    // };
    default:
      return state;
  }
};
